import type { RouteRecordRaw } from 'vue-router'
import { loadLocales } from '@/utils/i18n.utils'
import { useCommonStore } from '@/stores/CommonStore'

const LandingPageLayout = () => import('@/layouts/LandingPageLayout.vue')
const FeeWaiverHardshipForm = () =>
  import('@/pages/feeWaiver/FeeWaiverHardshipForm.vue')
const FeeWaiverSafetyForm = () =>
  import('@/pages/feeWaiver/FeeWaiverSafetyForm.vue')
const FeeWaiverConfirmation = () =>
  import('@/pages/feeWaiver/components/FeeWaiverConfirmation.vue')

export function getFeeWaiverRoutes(): RouteRecordRaw {
  return {
    name: 'feeWaiver',
    path: '/feewaiver',
    component: LandingPageLayout,
    redirect: { name: 'feeWaiverHardship' },
    beforeEnter: async () => {
      const commonStore = useCommonStore()

      // Wait for Remote Config to finish loading before checking the flag
      if (!commonStore.globalFlagsLoaded) {
        await new Promise<void>((resolve) => {
          const unwatch = commonStore.$subscribe(() => {
            if (commonStore.globalFlagsLoaded) {
              unwatch()
              resolve()
            }
          })
          // Resolve immediately if loaded between check and subscribe
          if (commonStore.globalFlagsLoaded) {
            unwatch()
            resolve()
          }
        })
      }

      if (!commonStore.featureFlags?.web_fee_waiver) {
        return '/not-found'
      }
      await loadLocales('feeWaiver')
    },
    children: [
      {
        name: 'feeWaiverHardship',
        path: '/feewaiver/hardship',
        component: FeeWaiverHardshipForm,
        meta: { requiresAuth: false }
      },
      {
        name: 'feeWaiverSafety',
        path: '/feewaiver/safety',
        component: FeeWaiverSafetyForm,
        meta: { requiresAuth: false }
      },
      {
        name: 'feeWaiverConfirmation',
        path: '/feewaiver/confirmation',
        component: FeeWaiverConfirmation,
        meta: { requiresAuth: false }
      }
    ]
  }
}
